import { CheckIcon, XIcon } from "lucide-react";
import type { FC } from "react";
import { StressPattern } from "@/components/stress-pattern";
import { AudioPlayButton } from "@/components/ui/audio-play-button";
import type { SyllableSegmentationData as SyllableSegmentation } from "@/lib/api-client";
import { cn } from "@/lib/cn";

export type AttemptInfo = {
  predictedStressIndex: number;
  correct: boolean;
  recording_b64: string;
  /** Kept to highlight syllables during playback, switched off until the backend timings are validated. */
  syllableSegmentation?: SyllableSegmentation;
};

export const AttemptDisplay: FC<{
  attempt: AttemptInfo;
  playLabel: string;
  syllableCount: number;
}> = ({ attempt, playLabel, syllableCount }) => (
  <div className="flex w-64 flex-col gap-2">
    <div
      className={cn(
        "flex h-40 w-64 flex-col items-center justify-center gap-4 rounded-xl border-2",
        attempt.correct && "border-success bg-success-muted",
        !attempt.correct && "border-destructive bg-destructive/10",
      )}
    >
      {/* To switch highlighting on, pass active and syllableLabels from syllableSegmentation. */}
      <StressPattern
        syllableCount={syllableCount}
        stressIndex={attempt.predictedStressIndex}
        scale="large"
      />
      <div
        className={cn(
          "flex h-7 w-7 items-center justify-center rounded-full text-primary-foreground",
          attempt.correct ? "bg-success" : "bg-destructive",
        )}
      >
        {attempt.correct ? (
          <CheckIcon className="h-4 w-4" />
        ) : (
          <XIcon className="h-4 w-4" />
        )}
      </div>
    </div>
    <AudioPlayButton
      data={{ kind: "b64", data: attempt.recording_b64 }}
      label={playLabel}
      showLabel
      className="h-11 rounded-xl"
    />
  </div>
);
